module.exports = __webpack_public_path__ + "static/media/blue-3.3fd044dc.png";